// extracted by mini-css-extract-plugin
module.exports = {"paperContainer":"PartnerProfile_paperContainer__30mGj","title":"PartnerProfile_title__2ivFd","mainContainer":"PartnerProfile_mainContainer__1S9TV"};